import { PaneResponsiveCardGrid } from '@/components/layout/pane-responsive-card-grid'
import { ListCardSkeleton } from '@/components/layout/list-card-skeleton'
import { cn } from '@/lib/utils'

export type PaneListSkeletonProps = {
  count?: number
  variant?: 'card' | 'row'
  /** Shown to assistive tech; layout is primary indicator. */
  ariaLabel?: string
  className?: string
}

export function PaneListSkeleton({
  count = 4,
  variant = 'card',
  ariaLabel = 'Loading list',
  className,
}: PaneListSkeletonProps) {
  if (variant === 'row') {
    return (
      <div
        className={cn('min-h-[12rem] space-y-2 py-2', className)}
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label={ariaLabel}
      >
        {Array.from({ length: count }).map((_, index) => (
          <ListCardSkeleton key={index} embedded showFooter />
        ))}
      </div>
    )
  }

  return (
    <div
      className={cn('min-h-[12rem] py-2', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      <PaneResponsiveCardGrid>
        {Array.from({ length: count }).map((_, index) => (
          <ListCardSkeleton key={index} showFooter />
        ))}
      </PaneResponsiveCardGrid>
    </div>
  )
}
